import Box from "@mui/material/Box";
import React, {FC, isValidElement} from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

export interface TitleBarProps {
    title?: string | React.ReactNode;
    extra?: React.ReactNode | string
    bgcolor?: string
}

export const TitleBar: FC<TitleBarProps> = ({title, extra, bgcolor = '#ecf3f7'}) => {
    return <Stack width={'100%'} direction={'row'} justifyContent={'space-between'} alignContent={'center'} alignItems={'center'}
                  sx={{padding: '8px 4px', borderRadius: '4px', bgcolor}}>
        {isValidElement(title) ? title : <Typography variant={"h6"} fontSize={16} fontWeight={500}>
            {title}
        </Typography>}
        {isValidElement(extra) ? extra : <Typography variant={"h6"} fontSize={15} color={'textSecondary'} fontWeight={500}>{extra}</Typography>}
    </Stack>
}